import mirrorkey from 'mirrorkey';
export default mirrorkey([
    'GET_MEMBERS_REQUEST',
    'GET_MEMBERS_SUCCESS',
    'GET_MEMBERS_FAIL',
    'GET_ALL_MEMBERS_REQUEST',
    'GET_ALL_MEMBERS_SUCCESS',
    'GET_ALL_MEMBERS_FAIL',
])